// extracted by mini-css-extract-plugin
export default {"warningContainer":"warningContainer__Th4vE","fadeInAnimation":"fadeInAnimation__1ULuU"};